import { COUPON_USAGE_REPORT } from 'actions/dataReport';

const initialState = {
  isLoading: false,
  couponUsageReport: [],
  page: 1,
  limit: 10,
  totalPages: 1,
  total: 1,
};

const couponUsageReportReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case COUPON_USAGE_REPORT.REQUEST: {
      return { ...state, isLoading: true };
    }
    case COUPON_USAGE_REPORT.SUCCESS: {
      return {
        ...state,
        isLoading: false,
        couponUsageReport: payload.results,
        page: payload.page,
        limit: payload.limit,
        totalPages: payload.totalPages,
        total: payload.totalResults,
      };
    }

    case COUPON_USAGE_REPORT.FAIL: {
      return { ...state, isLoading: false };
    }
    default:
      return { ...state };
  }
};
export default couponUsageReportReducer;